import { request, withQuery } from './client';
import type {
  StockListResponse, StockMovesResponse, StockTransferCreate, StockTransferReceive, StockTransferResult, StockTransferRow, StockWarehouseRef, WarehouseInput, WarehouseRow,
} from '@kassa/shared';

export interface StockListParams {
  q?: string;
  warehouseId?: string;
  categoryId?: string;
  low?: '1';
  page?: number;
  limit?: number;
  /** Sıralama (KT-108): name, -name, qty, -qty */
  sort?: string;
}

export const stockApi = {
  // Anbarlar və yerdəyişmə (KT-93)
  warehouses: () => request<WarehouseRow[]>('GET', '/api/warehouses'),
  warehouseCreate: (body: WarehouseInput) => request<{ id: string }>('POST', '/api/warehouses', body),
  warehouseUpdate: (id: string, body: WarehouseInput) => request<void>('PUT', `/api/warehouses/${encodeURIComponent(id)}`, body),
  warehouseSetMain: (id: string) => request<void>('POST', `/api/warehouses/${encodeURIComponent(id)}/main`),
  registerWarehouse: (registerId: string, warehouseId: string) => request<void>('PUT', `/api/warehouses/registers/${encodeURIComponent(registerId)}`, { warehouseId }),
  stockTransfers: (status?: string) => request<StockTransferRow[]>('GET', withQuery('/api/stock-transfers', { status })),
  stockTransferSend: (body: StockTransferCreate) => request<StockTransferResult>('POST', '/api/stock-transfers', body),
  stockTransferReceive: (id: string, body: StockTransferReceive) => request<StockTransferResult>('POST', `/api/stock-transfers/${encodeURIComponent(id)}/receive`, body),
  stockTransferCancel: (id: string, legId: string) => request<StockTransferResult>('POST', `/api/stock-transfers/${encodeURIComponent(id)}/cancel`, { id: legId }),
  stockWarehouses: () => request<StockWarehouseRef[]>('GET', '/api/stock/warehouses'),
  stock: (p: StockListParams) => request<StockListResponse>('GET', withQuery('/api/stock', { ...p })),
  stockMoves: (productId: string, p: { page?: number; limit?: number }) =>
    request<StockMovesResponse>('GET', withQuery(`/api/stock/${encodeURIComponent(productId)}/moves`, { ...p })),
};
